import React from "react";
import Products from "../image/products.jpg";
import Bread from "../image/bread.jpg";
import Shop from "../image/shop.webp";
import Typography  from "@mui/material/Typography";
import  Button  from "@mui/material/Button";
import Container   from "@mui/material/Container";
import home1 from "../image/home1.jpg";
import home2 from "../image/home2.jpg";
import home3 from "../image/home3.jpg";

import { Phones } from "./ProductInfo.jsx"

let index = 0;

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: Phones[index].name,
      img: Phones[index].img,
      desc: Phones[index].desc,
 
    };
    this.updateState = this.updateState.bind(this);
  }

  updateState() {
    let len = Phones.length - 1;
    if (index < len) {
      index = index + 1;
    } else {
      index = 0;
    }
    this.setState({
      name: Phones[index].name,
      img: Phones[index].img,
      desc: Phones[index].desc,
    });
  }

  render() {
    return (
   <Container sx={{textAlign:'center'}}>
            <Typography
              color="primary.light"
              variant="h1"
              component="h1">
             Cellular Connections
            </Typography>
            <Typography
                color="primary"
                variant="p"
                component="p">We are a small local electronics retailer and repair shop that focuses on mobile devices such as phones and tablets. If you are looking for repair services contact us via the contact page and we will try and get in contact with you as soon as possible.<br></br><br></br>We carry a number of different products phones,tablets,smart watches, and accessories for those devices. While we may not have the largest selection of products we make up for that service that we guarantee is better than the competition. 
            </Typography>
            <br></br>
            <br></br> 
            <img class="homeImg"src={home1} alt="icon" />
            <img class="homeImg"src={home2} alt="icon" />
            <img class="homeImg"src={home3} alt="icon" />
            <br></br>
            <Typography
              color="primary"
              variant="h2"
              component="h2">
              view some of our products
            </Typography>                
            <br></br>
            <img class="homeSide"src={this.state.img} alt="icon" />
            <br></br>
            <Button variant="outlined" onClick={this.updateState} color="primary.dark">next product</Button>
  
  </Container >
    );
  }
}


export default Home;
